import LoadingButton from '@mui/lab/LoadingButton'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { ButtonProps } from '@mui/material'
import Button from '@mui/material/Button'

type Props = {
  open: boolean
  title: string
  text: string
  onConfirm: () => void
  onCancel: () => void
  cancelText?: string
  confirmText?: string
  cancelButtonProps?: ButtonProps
  confirmButtonProps?: ButtonProps
  isLoadingConfirm?: boolean
}

export const DialogConfirm = ({
  open,
  title,
  onConfirm,
  onCancel,
  text,
  confirmText,
  cancelText,
  confirmButtonProps,
  cancelButtonProps,
  isLoadingConfirm,
}: Props) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth={'xs'}
      sx={{
        '& .MuiDialog-paper': {
          width: '100%',
        },
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{text}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          {...cancelButtonProps}
          onClick={onCancel}
        >
          {cancelText || 'Cancel'}
        </Button>
        <LoadingButton
          color="error"
          variant="contained"
          {...confirmButtonProps}
          onClick={onConfirm}
          loading={isLoadingConfirm}
        >
          {confirmText || 'Confirm'}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
